'use client'
import { jsx } from "react/jsx-runtime";
import { Drawer } from "../../Drawer/index.js";
import { OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { Calendar } from "../Calendar/Calendar.js";
function OverlayCalendar({ mode = 'single', handleCalendarChange, components, open = false, handleDrawerState, heading = 'Choose Dates', popOverText, selected, footer, subHeading, ...restProps }) {
    const handleClose = ()=>{
        handleDrawerState(false);
    };
    return /*#__PURE__*/ jsx("div", {
        className: "flex flex-row",
        children: /*#__PURE__*/ jsx(Drawer, {
            title: "Calendar",
            description: "Overlay Calendar",
            direction: "bottom",
            showCloseButton: false,
            showDragHandle: false,
            open: open,
            scroll: "body",
            footer: footer,
            stickyFooter: !!footer,
            headingCustomNode: /*#__PURE__*/ jsx(OverlayTitle, {
                heading: heading,
                subHeading: subHeading,
                handleClose: handleClose,
                popOverText: popOverText,
                slots: {
                    container: 'px-2 pb-4'
                }
            }),
            children: /*#__PURE__*/ jsx("div", {
                className: "relative flex w-full p-4",
                children: /*#__PURE__*/ jsx(Calendar, {
                    isMobile: true,
                    mode: mode,
                    handleCalendarChange: handleCalendarChange,
                    components: components,
                    selected: selected,
                    ...restProps
                })
            })
        })
    });
}
export { OverlayCalendar };
